import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ff7fc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Note", -1))
const _hoisted_3 = { class: "footer_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    width: "475px",
    class: "contract_assign_modal",
    onOnClose: $setup.onCloseModal,
    headerTitle: "Phase # notes"
  }, {
    body: _withCtx(() => [
      _createVNode(_component_v_form, {
        rules: $setup.validation,
        ref: "noteFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_select, {
            modelValue: $setup.selectedPhaseTaskId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedPhaseTaskId) = $event)),
            items: $setup.getTaskList,
            class: "input_field",
            "bg-color": "#fff",
            rules: $setup.validation.select,
            variant: "outlined",
            placeholder: "select task",
            "item-value": "id",
            "item-title": "name"
          }, null, 8, ["modelValue", "items", "rules"]),
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_textarea, {
              label: "",
              modelValue: $setup.phaseNote,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.phaseNote) = $event)),
              rules: $setup.validation.note,
              variant: "outlined",
              class: "input_field"
            }, null, 8, ["modelValue", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          label: "Cancel",
          onClick: $setup.onCloseModal,
          class: "button button-purple-border"
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Save",
          onClick: $setup.onSaveTaskNote,
          class: "button button-orange",
          isActive: true,
          loading: $setup.Loading
        }, null, 8, ["onClick", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}